module.exports = {"fileName":"/contracts/core/common/Once.sol","name":"Once","abi":[],"source":"/**\n * Copyright 2017–2018, LaborX PTY\n * Licensed under the AGPL Version 3 license.\n */\n\npragma solidity ^0.4.11;\n\ncontract Once {\n    mapping (bytes4 => bool) methods;\n\n    modifier onlyOnce() {\n        if (!methods[msg.sig]) {\n            _;\n            methods[msg.sig] = true;\n        }\n    }\n}\n","abiDocs":[]}


//////////////////
// WEBPACK FOOTER
// ./docs/Once.json
// module id = 1130
// module chunks = 0